import { BOOKING_PORTAL_REFERRER_SOURCE } from "../constants";
import { getAdminPortalUrlWithSource } from "./getAdminPortalUrlWithSource";

export const BUSINESS_PORTAL_PATH = "/business/";

// The external admin portal and the in-SPA BusinessApp use different route
// names for the same page (e.g. admin `/users` is `user-management` in the
// BusinessApp tab config). Map the known differences so internal links resolve
// instead of falling through to the default tab.
const ADMIN_TO_BUSINESS_ROUTE: Record<string, string> = {
  "/users": "user-management",
  "/business-profile": "loyalty-programs",
};

/**
 * Returns the destination for an admin link. When the `corp-business-tabs`
 * flag is off, this mirrors `getAdminPortalUrlWithSource` (external admin
 * portal). When on, it maps to the in-SPA `/business/` route, translating
 * known route-name differences and preserving the referrer source and any
 * extra query params.
 */
export const getAdminOrBusinessUrl = (
  path: string | undefined,
  businessTabsEnabled: boolean,
  extraQuery?: string
): string => {
  if (!businessTabsEnabled) {
    const base = getAdminPortalUrlWithSource(path);
    return extraQuery ? `${base}&${extraQuery}` : base;
  }

  const suffix = path
    ? ADMIN_TO_BUSINESS_ROUTE[path] ?? path.replace(/^\//, "")
    : "";
  const query = [BOOKING_PORTAL_REFERRER_SOURCE, extraQuery]
    .filter(Boolean)
    .join("&");

  return `${BUSINESS_PORTAL_PATH}${suffix}?${query}`;
};
